import "@/App.css";
import "../src/i18n"; // initialize i18next
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { PreferencesProvider } from "./contexts/PreferencesContext";
import LandingPage from "./pages/LandingPage";
import ProtectedRoute, { OwnerRoute } from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import LoginPage from "./pages/LoginPage";
import SetPasswordPage from "./pages/SetPasswordPage";
import DashboardPage from "./pages/DashboardPage";
import NegociosPage from "./pages/NegociosPage";
import EmpresasPage from "./pages/EmpresasPage";
import ContatosPage from "./pages/ContatosPage";
import ContratosPage from "./pages/ContratosPage";
import CobrancasPage from "./pages/CobrancasPage";
import ProdutosPage from "./pages/ProdutosPage";
import CamposPersonalizadosPage from "./pages/CamposPersonalizadosPage";
import PipelinePage from "./pages/PipelinePage";
import AuditoriaPage from "./pages/AuditoriaPage";
import AparenciaPage from "./pages/AparenciaPage";
import GeralPage from "./pages/GeralPage";
import UsuariosPage from "./pages/UsuariosPage";
import TenantsPage from "./pages/TenantsPage";
import OwnerLayout from "./layouts/OwnerLayout";
import PerfisPage from "./pages/PerfisPage";
import RelatoriosPage from "./pages/RelatoriosPage";
import ModulosPage from "./pages/ModulosPage";
import TarefasPage from "./pages/TarefasPage";
import TarefasConfigPage from "./pages/TarefasConfigPage";
import AutomacoesPage from "./pages/AutomacoesPage";
import IntegracoesPage from "./pages/IntegracoesPage";
import NotificacoesPage from "./pages/NotificacoesPage";
import FormsPage from "./pages/settings/FormsPage";
import FormBuilderPage from "./pages/settings/FormBuilderPage";
import PublicFormPage from "./pages/PublicFormPage";
import ImportPage from "./pages/settings/ImportPage";
import OwnerIntegracoesPage from "./pages/OwnerIntegracoesPage";
import OwnerGeralPage from "./pages/OwnerGeralPage";
import TermosDeUsoPage from "./pages/TermosDeUsoPage";
import PoliticaPrivacidadePage from "./pages/PoliticaPrivacidadePage";
import CheckoutPage from "./pages/CheckoutPage";
import CheckoutSuccessPage from "./pages/CheckoutSuccessPage";
import EmailModelosPage from "./pages/EmailModelosPage";
import EmailCampanhasPage from "./pages/EmailCampanhasPage";
import RobinRoundPage from "./pages/RobinRoundPage";
import LeadsPage from "./pages/LeadsPage";

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/set-password" element={<SetPasswordPage mode="set" />} />
      <Route path="/reset-password" element={<SetPasswordPage mode="reset" />} />
      <Route path="/dashboard" element={<ProtectedRoute><Layout><DashboardPage /></Layout></ProtectedRoute>} />
      <Route path="/negocios" element={<ProtectedRoute><Layout><NegociosPage /></Layout></ProtectedRoute>} />
      <Route path="/leads" element={<ProtectedRoute><Layout><LeadsPage /></Layout></ProtectedRoute>} />
      <Route path="/empresas" element={<ProtectedRoute><Layout><EmpresasPage /></Layout></ProtectedRoute>} />
      <Route path="/contatos" element={<ProtectedRoute><Layout><ContatosPage /></Layout></ProtectedRoute>} />
      <Route path="/contratos" element={<ProtectedRoute><Layout><ContratosPage /></Layout></ProtectedRoute>} />
      <Route path="/cobrancas" element={<ProtectedRoute><Layout><CobrancasPage /></Layout></ProtectedRoute>} />
      <Route path="/produtos" element={<ProtectedRoute><Layout><ProdutosPage /></Layout></ProtectedRoute>} />
      <Route path="/relatorios" element={<ProtectedRoute><Layout><RelatoriosPage reportKey="vendas" /></Layout></ProtectedRoute>} />
      <Route path="/relatorios/performance" element={<ProtectedRoute><Layout><RelatoriosPage reportKey="performance" /></Layout></ProtectedRoute>} />
      <Route path="/relatorios/vendas" element={<ProtectedRoute><Layout><RelatoriosPage reportKey="vendas" /></Layout></ProtectedRoute>} />
      <Route path="/relatorios/forecast" element={<ProtectedRoute><Layout><RelatoriosPage reportKey="forecast" /></Layout></ProtectedRoute>} />
      <Route path="/relatorios/pipeline" element={<ProtectedRoute><Layout><RelatoriosPage reportKey="pipeline" /></Layout></ProtectedRoute>} />
      <Route path="/relatorios/conversao" element={<ProtectedRoute><Layout><RelatoriosPage reportKey="conversao" /></Layout></ProtectedRoute>} />
      <Route path="/relatorios/tarefas" element={<ProtectedRoute><Layout><RelatoriosPage reportKey="tarefas" /></Layout></ProtectedRoute>} />
      <Route path="/relatorios/whatsapp" element={<ProtectedRoute><Layout><RelatoriosPage reportKey="whatsapp" /></Layout></ProtectedRoute>} />
      <Route path="/relatorios/atividades" element={<ProtectedRoute><Layout><RelatoriosPage reportKey="atividades" /></Layout></ProtectedRoute>} />
      <Route path="/relatorios/aging" element={<ProtectedRoute><Layout><RelatoriosPage reportKey="aging" /></Layout></ProtectedRoute>} />
      <Route path="/relatorios/cohort" element={<ProtectedRoute><Layout><RelatoriosPage reportKey="cohort" /></Layout></ProtectedRoute>} />
      <Route path="/relatorios/executive" element={<ProtectedRoute><Layout><RelatoriosPage reportKey="executive" /></Layout></ProtectedRoute>} />
      <Route path="/tarefas" element={<ProtectedRoute><Layout><TarefasPage /></Layout></ProtectedRoute>} />
      <Route path="/notificacoes" element={<ProtectedRoute><Layout><NotificacoesPage /></Layout></ProtectedRoute>} />
      <Route path="/configuracoes/campos" element={<ProtectedRoute><Layout><CamposPersonalizadosPage /></Layout></ProtectedRoute>} />
      <Route path="/configuracoes/pipeline" element={<ProtectedRoute><Layout><PipelinePage /></Layout></ProtectedRoute>} />
      <Route path="/configuracoes/aparencia" element={<ProtectedRoute><Layout><AparenciaPage /></Layout></ProtectedRoute>} />
      <Route path="/configuracoes/geral" element={<ProtectedRoute><Layout><GeralPage /></Layout></ProtectedRoute>} />
      <Route path="/configuracoes/modulos" element={<ProtectedRoute><Layout><ModulosPage /></Layout></ProtectedRoute>} />
      <Route path="/configuracoes/perfis" element={<ProtectedRoute><Layout><PerfisPage /></Layout></ProtectedRoute>} />
      <Route path="/configuracoes/usuarios" element={<ProtectedRoute><Layout><UsuariosPage /></Layout></ProtectedRoute>} />
      <Route path="/configuracoes/tarefas" element={<ProtectedRoute><Layout><TarefasConfigPage /></Layout></ProtectedRoute>} />
      <Route path="/configuracoes/automacoes" element={<ProtectedRoute><Layout><AutomacoesPage /></Layout></ProtectedRoute>} />
      <Route path="/configuracoes/integracoes" element={<ProtectedRoute><Layout><IntegracoesPage /></Layout></ProtectedRoute>} />
      <Route path="/configuracoes/formularios" element={<ProtectedRoute><Layout><FormsPage /></Layout></ProtectedRoute>} />
      <Route path="/configuracoes/formularios/:id" element={<ProtectedRoute><Layout><FormBuilderPage /></Layout></ProtectedRoute>} />
      <Route path="/configuracoes/importar" element={<ProtectedRoute><Layout><ImportPage /></Layout></ProtectedRoute>} />
      <Route path="/configuracoes/robin-round" element={<ProtectedRoute><Layout><RobinRoundPage /></Layout></ProtectedRoute>} />
      {/* Public form — no auth, no layout */}
      <Route path="/f/:slug" element={<PublicFormPage />} />
      <Route path="/email/modelos" element={<ProtectedRoute><Layout><EmailModelosPage /></Layout></ProtectedRoute>} />
      <Route path="/email/campanhas" element={<ProtectedRoute><Layout><EmailCampanhasPage /></Layout></ProtectedRoute>} />
      <Route path="/checkout" element={<ProtectedRoute><CheckoutPage /></ProtectedRoute>} />
      <Route path="/checkout/sucesso" element={<ProtectedRoute><CheckoutSuccessPage /></ProtectedRoute>} />
      <Route path="/termos-de-uso" element={<TermosDeUsoPage />} />
      <Route path="/politica-de-privacidade" element={<PoliticaPrivacidadePage />} />
      <Route path="/owner/tenants" element={<OwnerRoute><OwnerLayout><TenantsPage /></OwnerLayout></OwnerRoute>} />
      <Route path="/owner/configuracoes/integracoes" element={<OwnerRoute><OwnerLayout><OwnerIntegracoesPage /></OwnerLayout></OwnerRoute>} />
      <Route path="/owner/configuracoes/geral" element={<OwnerRoute><OwnerLayout><OwnerGeralPage /></OwnerLayout></OwnerRoute>} />
      <Route path="/owner" element={<OwnerRoute><Navigate to="/owner/tenants" replace /></OwnerRoute>} />
      <Route path="/configuracoes/auditoria" element={<ProtectedRoute><Layout><AuditoriaPage /></Layout></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

import { TooltipProvider } from "./components/ui/tooltip";
import { AppearanceProvider } from "./contexts/AppearanceContext";
import { ModulesProvider } from "./contexts/ModulesContext";
import { Toaster } from "./components/ui/sonner";
import DialerWidget from "./components/DialerWidget";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter>
        <AuthProvider>
          <AppearanceProvider>
            <ModulesProvider>
              <PreferencesProvider>
                <TooltipProvider delayDuration={300}>
                  <AppRouter />
                  <Toaster position="bottom-center" richColors />
                  <DialerWidget />
                </TooltipProvider>
              </PreferencesProvider>
            </ModulesProvider>
          </AppearanceProvider>
        </AuthProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
